import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../app-state/Hooks';

export function AuthGuard({
  redirectTo
}: Readonly<{
  redirectTo: string;
}>) {
  const isLoggedIn = useAppSelector((s) => s.user.loggedIn);

  if (!isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
